import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Dropdown, DropdownErrorMatcher } from '@nx-customer-apps/shared/utils';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { NgClass } from '@angular/common';
import { MatSelect, MatOption } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';
import { FormFieldStylesPipe } from '../../pipes';

@Component({
    selector: 'vp-dropdown',
    templateUrl: './dropdown.component.html',
    imports: [
        MatFormField,
        NgClass,
        MatLabel,
        MatSelect,
        ReactiveFormsModule,
        MatOption,
        MatError,
        ComponentsModule,
        TranslatePipe,
        FormFieldStylesPipe
    ]
})
export class DropdownComponent {
    @Input() question: Dropdown;
    @Input() form: FormGroup;
    public matcher = new DropdownErrorMatcher();

    get control(): FormControl {
        return this.form.get((this.question as Dropdown).key) as FormControl;
    }

    get errorMessage(): string {
        const errorMessage = this.control?.errors?.['message'];
        return errorMessage || (this.question as Dropdown).defaultErrorMessage;
    }
}
